export let crossFormatPersonNameGV = false;

export function setCrossFormatPersonNameGV(value) {
	crossFormatPersonNameGV = value;
}
